import { DocumentPreviewConstant } from "presentation/constant/DocumentPreview/DocumentPreviewConstant";
import { useDocumentPreviewTracked } from "presentation/store/DocumentPreview/DocumentPreviewProvider";
import { convertDateToDateForComponent } from "presentation/utils/timeUtil";

export const DocumentPreviewEditHeaderPanel = () => {

    const [documentPreviewState] = useDocumentPreviewTracked();
    const { currentSelectedData } = documentPreviewState;

    return <>
        <div className="headerInfo">
            <div className="fourColumns">
                <div className={"item"}>
                    <div className={"label"}>
                        {DocumentPreviewConstant.Title.CO_VSL_VOY}
                    </div>
                    <div className={"value"}>
                        {(currentSelectedData?.consortiumCode && currentSelectedData?.vesselCode && currentSelectedData?.voyageCode) ? `${currentSelectedData?.consortiumCode}/
                            ${currentSelectedData?.vesselCode}/
                            ${currentSelectedData?.voyageCode}` : ''}
                    </div>
                </div>

                <div className={"item"}>
                    <div className={"label"}>
                        {DocumentPreviewConstant.Title.ETD}
                    </div>
                    <div className={"value"}>
                        {convertDateToDateForComponent(currentSelectedData?.etd)}
                    </div>
                </div>

                <div className={"item"}>
                    <div className={"label"}>
                        {DocumentPreviewConstant.EditTable.DRAFT_DOC_NO}
                    </div>
                    <div className={"value"}>
                        {currentSelectedData?.draftDocNo as string}
                    </div>
                </div>

                <div className={"item"}>
                    <div className={"label"}>
                        {DocumentPreviewConstant.Title.BILL_TO_COMPANY}
                    </div>
                    <div className={"value"}>
                        {currentSelectedData?.billToCompany as string}
                    </div>
                </div>

            </div>
        </div>
    </>
}